import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import CreateUserView from "../views/CreateUserView.vue";
import CommandView from "../views/CommandView.vue";
import ListUserView from "../views/ListUserView.vue";
import EvenementView from "../views/EvenementView.vue";
import CreateEvenementView from "../views/CreateEvenementView.vue";
import ListUserEvenementView from "../views/ListUserEvenementView.vue";
import LoginView from '../views/LoginView.vue';
import ActivateView from '../views/ActivateView.vue';
import {loadAccount} from '../services/AuthService';

Vue.use(VueRouter)

const routes = [
    {path: '/login', component: LoginView, meta: {public: true}},
    {path: '/activate', component: ActivateView, meta: {public: true}},
    {
        path: '/',
        name: 'home-view',
        component: HomeView
    },
    {
        path: '/list/users',
        name: 'list-user-view',
        component: ListUserView
    },
    {
        path: '/create/user',
        name: 'create-user-view',
        component: CreateUserView,
        props: true
    },
    {
        path: '/create/command',
        name: 'command-view',
        component: CommandView
    },
    {
        path: '/list/evenement',
        name: 'evenement-view',
        component: EvenementView
    },
    {
        path: '/create/evenement',
        name: 'create-evenement-view',
        component: CreateEvenementView
    },
    {
        path: '/list/users/evenement/:event_id',
        name: 'list-user-evenement-view',
        component: ListUserEvenementView,
        props: true
    }
];

const router = new VueRouter({
    mode: 'history',
    routes,
    base: './'
})

router.beforeEach(async (to, from, next) => {
    if (to.meta.public) return next();
    try {
        const account = await loadAccount();
        if (!account) return next('/login');
        next();
    } catch (error) { next('/login'); }
});

export default router;
